import * as React from "react";
import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import styled from "@emotion/styled";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { getFilesList, uploadFile } from "../provider/query-api";
import useChatbot from "../provider/chatbot_provider";
import { useLocation, useSearchParams } from "react-router-dom";
import { getClient } from "../utils/http";
import { toast } from "react-toastify";
import { useAuth } from "../provider/auth_provider";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const pathToTitleMapping: Record<string, string> = {
  "/document": "Document Analyzer",
  "/legal": "Legal AI - Petition",
  "/qc": "Quote Computation",
  "/wc-claims":
    "Supported Documents pdf, docx, doc, xlsx, xls, eml, png, jpg, jpeg",
  "/tech-eo":
    "Supported Documents pdf, docx, doc, xlsx, xls, xlsm, csv, msg, eml, pptx, jpg, jpeg, png, txt",
  "/tech-do":
    "Supported Documents pdf, docx, doc, xlsx, xls, xlsm, csv, msg, eml, pptx, jpg, jpeg, png, txt",
  "/dtr": "DTR Details Extractor",
};

export default function ManageDocs({
  setVectorName,
  vectorName,
  handleClose,
}: any) {
  // const [vectorNameText, setVectorNameText] = useState("");
  const [fileUploadList, setFileUploadList] = useState([] as any);
  const [uploadLoading, setUploadLoading] = useState(false);
  // const [error, setError] = useState("");
  const {
    chats,
    updateSuggestions,
    fileList,
    setFileList,
    setWCClaimDetails,
    setIsDocsProcessing,
  } = useChatbot();
  const { userDetails } = useAuth();
  const { pathname } = useLocation();

  const readFileAsBase64 = (
    file: File,
  ): Promise<{
    name: string;
    type: string;
    size: number;
    base64: string;
  }> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () =>
        resolve({
          name: file.name,
          type: file.type,
          size: file.size,
          base64: (reader.result as string) || "",
        });
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  // const wcClaimUpload = async (endpoint: string) => {
  //   try {
  //     setUploadLoading(true);
  //     if (fileUploadList.length) {
  //       let formData = new FormData();
  //       fileUploadList?.forEach((file: File) => {
  //         formData.append("files", file);
  //       });
  //       const items = await Promise.all(fileUploadList.map(readFileAsBase64));
  //       let response = null;
  //       if (endpoint === "wc-claims") {
  //         const files = items?.map((base64Data) => ({
  //           filename: base64Data?.name,
  //           content: base64Data?.base64.split(",")[1],
  //         }));
  //         response = await getClient(endpoint).post(
  //           "/process_claim_base64",
  //           {
  //             files,
  //           },
  //           {
  //             headers: {
  //               Authorization: `Bearer ${localStorage.getItem("apigeeToken")}`,
  //               "Content-Type": "application/json",
  //             },
  //           },
  //         );
  //       } else if (["tech-eo", "tech-do"].includes(endpoint)) {
  //         const files = items?.map((base64Data) => ({
  //           filename: base64Data?.name,
  //           content_base64: base64Data?.base64.split(",")[1],
  //         }));
  //         let userId = `${userDetails?.userId?.toString()}${Date.now()}`;
  //         const res = await getClient(endpoint).post(
  //           "/ingest_base64",
  //           {
  //             user_id: userId,
  //             files,
  //           },
  //           {
  //             headers: {
  //               Authorization: `Bearer ${localStorage.getItem("apigeeToken")}`,
  //               "Content-Type": "application/json",
  //             },
  //           },
  //         );
  //         if (res?.data) {
  //           debugger;
  //           if (res?.data?.responseCode === "401") {
  //             localStorage.removeItem("userDetails");
  //             localStorage.removeItem("apigeeToken");
  //             window.location.pathname = "/login";
  //             return;
  //           }
  //           const payload = {
  //             user_id: userId,
  //             include_lor: true,
  //             type: endpoint === "tech-eo" ? "tech_eo" : "tech_do",
  //           };
  //           response = await getClient(endpoint).post(
  //             "/reserve_note",
  //             payload,
  //             {
  //               headers: {
  //                 Authorization: `Bearer ${localStorage.getItem("apigeeToken")}`,
  //                 "Content-Type": "application/json",
  //               },
  //             },
  //           );
  //         }
  //       }
  //       if (response?.data?.responseCode === "401") {
  //         localStorage.removeItem("userDetails");
  //         localStorage.removeItem("apigeeToken");
  //         window.location.pathname = "/login";
  //         return;
  //       }
  //       setWCClaimDetails(response?.data || null);
  // console.log(response?.data, "wc-response");

  // setFileList((prev: Record<string, any>[]) => {
  //   let updatedFiles: Record<string, any> = [];
  //   [...fileUploadList]?.forEach((file: File) => {
  //     if (
  //       !updatedFiles?.filter(
  //         (prevFile: Record<string, any>) =>
  //           prevFile?.name === file?.name,
  //       )?.length
  //     )
  //       updatedFiles.push({
  //         isSelected: true,
  //         name: file?.name,
  //       });
  //   });
  //   return updatedFiles;
  // });
  // setFileUploadList([]);
  // handleClose();
  // toast.success("Documents Uploaded Successfully!");
  //     }
  //   } catch (err) {
  //     console.warn(err, "wc-claim-error");
  //     toast.error(`Upload failed: ${err}`);
  //   } finally {
  //     setUploadLoading(false);
  //   }
  // };

  const pollUploadStatus = async (
    client: any,
    ingestId: string,
  ): Promise<boolean> => {
    const POLLING_INTERVAL = 30000; // 30 seconds
    const MAX_RETRIES = 20; // Total 10 minutes (20 * 30s)
    let retries = 0;
    let isCompleted = false;

    while (!isCompleted && retries < MAX_RETRIES) {
      try {
        const statusRes = await client.get(`/ingest/status/${ingestId}`, {
          // const statusRes = await client.get(`/techeo-ingest-result/${ingestId}`, {
          headers: {
            // Authorization: `Bearer ${localStorage.getItem("apigeeToken")}`,
            "Content-Type": "application/json",
          },
        });
        const status = statusRes?.data?.status;

        if (status === "completed") {
          isCompleted = true;
          return true;
        }

        if (status === "failed") {
          throw new Error("Server reported processing failure.");
        }

        // If not completed, increment retries and wait
        retries++;
        console.log(`Polling... Attempt ${retries} of ${MAX_RETRIES}`);
        await new Promise((resolve) => setTimeout(resolve, POLLING_INTERVAL));
      } catch (err) {
        console.error("Polling error:", err);
        // Decide if you want to stop on network error or keep trying
        throw err;
      }
    }
    if (!isCompleted) {
      throw new Error("Polling timed out after 10 minutes.");
    }
    return false;
  };

  const wcClaimUpload = async (endpoint: string) => {
    if (!fileUploadList.length) return;

    try {
      setUploadLoading(true);
      const items = await Promise.all(fileUploadList.map(readFileAsBase64));
      const client = getClient(endpoint);
      let response = null;

      if (endpoint === "wc-claims") {
        const files = items.map((item) => {
        const testname = item?.name || "";
        const lastDot = testname.lastIndexOf(".");
        const newname = testname.substring(0, lastDot);
        const ext = testname.substring(lastDot);
        const cleanName = newname.replace(/[^A-Za-z0-9_-]+/g, "");
        return {
          filename: cleanName + ext,
          content: item?.base64?.split(",")[1],
        };
      });
        response = await client.post(
          "/process_claim_base64",
          // "/wc-process-claim-base64",
          { files, nt_id: userDetails?.username || "" },
          {
            headers: {
              // Authorization: `Bearer ${localStorage.getItem("apigeeToken")}`,
              "Content-Type": "application/json",
            },
          },
        );
      } else if (["tech-eo", "tech-do"].includes(endpoint)) {
        const userId = `${userDetails?.userId}${Date.now()}`;
        const files = items.map((item) => ({
          filename: item?.name,
          content_base64: item?.base64.split(",")[1],
        }));

        // 1. Initial Ingest
        const ingestRes = await client.post(
          "/ingest_base64",
          // "/techeo-ingest-base64",
          {
            user_id: userId,
            files,
          },
          {
            headers: {
              // Authorization: `Bearer ${localStorage.getItem("apigeeToken")}`,
              "Content-Type": "application/json",
            },
          },
        );

        if (ingestRes?.data) {
          // 2. Start Polling
          toast.info("Files received. Processing may take a few minutes...", {
            autoClose: 5000,
          });
          handleClose();
          setIsDocsProcessing(true);
          try {
            await pollUploadStatus(client, ingestRes?.data?.job_id);

            // 3. This only runs if pollUploadStatus returns true
            const payload = {
              nt_id: userDetails?.username || "",
              user_id: userId,
              include_lor: false,
              type: endpoint.replace("-", "_"),
            };

            response = await client.post("/reserve_note", payload, {
              // response = await client.post("/techeo-reserve-note", payload, {
              headers: {
                // Authorization: `Bearer ${localStorage.getItem("apigeeToken")}`,
                "Content-Type": "application/json",
              },
            });
          } catch (pollError) {
            // Handled the case where polling fails or times out
            toast.error("Documents processing failed!");
            console.warn(pollError, "document-processing-error");
            setUploadLoading(false);
            setIsDocsProcessing(false);
            return; // Stop execution
          }
        }
      }

      if (response?.data) {
        setWCClaimDetails(response.data);
        console.log(response?.data, "wc-response");

        // setFileList((prev: Record<string, any>[]) => {
        //   let updatedFiles: Record<string, any> = [];
        //   [...fileUploadList]?.forEach((file: File) => {
        //     if (
        //       !updatedFiles?.filter(
        //         (prevFile: Record<string, any>) =>
        //           prevFile?.name === file?.name,
        //       )?.length
        //     )
        //       updatedFiles.push({
        //         isSelected: true,
        //         name: file?.name,
        //       });
        //   });
        //   return updatedFiles;
        // });
        setFileUploadList([]);
        handleClose();
        toast.success("Documents Uploaded Successfully!");
      }
    } catch (err) {
      toast.error("Documents processing failed!");
      console.warn(err, "document-processing-error");
    } finally {
      setUploadLoading(false);
      setIsDocsProcessing(false);
    }
  };

  const dtrUpload = async (endpoint: string) => {
    try {
      setUploadLoading(true);
      if (fileUploadList.length) {
        let base64Data = await readFileAsBase64(fileUploadList?.[0]);
        const fileName = base64Data?.name?.replace(/[^a-zA-Z0-9.]/g, "");
        const payload = {
          UNIQUE_INDENTIFIER: userDetails?.userId,
          USER_ID: userDetails?.username || "",
          FILE_NAME: fileName,
          FILE_BYTES: base64Data?.base64.split(",")[1],
          TASK_TYPE : "combined",
        };
        const response = await getClient(endpoint).post("/input", payload);
        setWCClaimDetails(response?.data?.result || null);
        console.log(response?.data?.result, "dtr-response");

        // setFileList((prev: Record<string, any>[]) => {
        //   let updatedFiles = [...prev];
        //   [...fileUploadList]?.forEach((file: File) => {
        //     if (
        //       !updatedFiles?.filter(
        //         (prevFile: Record<string, any>) =>
        //           prevFile?.name === file?.name,
        //       )?.length
        //     )
        //       updatedFiles.push({
        //         isSelected: true,
        //         name: file?.name,
        //       });
        //   });
        //   return updatedFiles;
        // });
        setFileUploadList([]);
        handleClose();
        toast.success("Documents Uploaded Successfully!");
      }
    } catch (err) {
      console.warn(err, "dtr-error");
      toast.error(`Upload failed: ${err}`);
    } finally {
      setUploadLoading(false);
    }
  };

  const handleFileUpload = async () => {
    if (["/wc-claims", "/tech-eo", "/tech-do"].includes(pathname)) {
      await wcClaimUpload(pathname.slice(1));
      return;
    } else if (["/dtr"].includes(pathname)) {
      await dtrUpload(pathname.slice(1));
      return;
    }
    setUploadLoading(true);
    await Promise.all(
      Array(fileUploadList.length)
        .fill(1)
        .map(async (fileUploadVal: any, index: number) => {
          const base64Data = await readFileAsBase64(fileUploadList[index]);
          const uploadStatus = await uploadFile(
            vectorName,
            fileUploadList[index].name,
            base64Data?.base64 + "",
            pathname.slice(1),
          );
          return uploadStatus;
        }),
    );

    setFileUploadList([]);
    refreshFileList();
    setUploadLoading(false);
  };

  // const handleSubmit = () => {
  //   if (vectorNameText.trim() === "") {
  //     setError("Please enter a profile name.");
  //   } else {
  //     setError("");
  //     setVectorName(vectorNameText);
  //   }
  // };

  const refreshFileList = React.useCallback(() => {
    getFilesList(vectorName, pathname.slice(1)).then((data) => {
      updateSuggestions(data.questionSuggestions);
      setFileList((prev: Record<string, any>[]) => {
        let updatedFiles = [...prev];
        data.files?.forEach((file: string) => {
          if (
            !updatedFiles?.filter(
              (prevFile: Record<string, any>) => prevFile?.name === file,
            )?.length
          )
            updatedFiles.push({
              isSelected: true,
              name: file,
            });
        });
        return updatedFiles;
      });
    });
  }, [updateSuggestions, vectorName]);

  useEffect(() => {
    if (!["/wc-claims", "/tech-eo", "/tech-do", "/dtr"].includes(pathname))
      refreshFileList();
  }, [refreshFileList, vectorName, chats]);

  return (
    <>
      {/* {!vectorName && (
        <Box sx={{ width: "auto" }}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            mb={1.5}
            sx={{ fontSize: "1.2rem", fontWeight: 600 }}
          >
            Enter Profile Name
          </Typography>
          <Box
            sx={{
              display: "flex",
              gap: "0.625rem",
              borderRadius: "0.625rem !important",
            }}
            id="testing"
          >
            <TextField
              error={!!error}
              id="outlined-error-helper-text"
              sx={{
                borderRadius: "0.125rem !important",
                fontSize: 13,
                "& .MuiInputBase-root.MuiOutlinedInput-root": {
                  borderRadius: "0.625rem",
                },
              }}
              // label={error ? "Error" : "Profile Name"}
              value={vectorNameText}
              placeholder="Profile Name"
              helperText={error || " "}
              onChange={(e) => {
                setVectorNameText(e.target.value);
                if (error) {
                  setError("");
                }
              }}
            />
            <Button
              variant="contained"
              color="primary"
              sx={{
                p: 2,
                px: 4,
                width: "unset",
                borderRadius: "0.75rem",
                height: "3.3125rem",
              }}
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Box>
        </Box>
      )} */}
      {!vectorName && (
        <>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "0.625rem",
              flexWrap: "wrap",
            }}
          >
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              sx={{ fontWeight: 600, fontSize: "1.2rem" }}
            >
              Add Documents
            </Typography>
            {/* <TextField variant="standard" type="file" /> */}
            {/* <input type="file" multiple onChange={(e) => { console.log(e.target.files?.item(1)?.name) }}  /> */}
            <Button
              component="label"
              role={undefined}
              variant="outlined"
              tabIndex={-1}
              startIcon={<CloudUploadIcon />}
            >
              Select files
              <VisuallyHiddenInput
                type="file"
                accept="application/pdf"
                multiple
                onChange={(e: any) => {
                  // check if each file size is less than 2 MB
                  const fileList = Array(e.target.files.length)
                    .fill(1)
                    .map((fileVal: any, index: number) => {
                      if (
                        e.target.files.item(index)?.size >
                        (["/dtr"].includes(pathname)
                          ? 5000000
                          : ["/wc-claims"].includes(pathname)
                            ? 15000000
                            : ["/tech-eo", "/tech-do"].includes(pathname)
                              ? 50000000
                              : 2000000)
                      ) {
                        alert(
                          `File ${e.target.files.item(index)?.name
                          } is too large`,
                        );
                        return null;
                      }
                      return e.target.files.item(index);
                    })
                    .filter((file: any) => {
                      return file;
                    });

                  if (fileList.length > 0) {
                    setFileUploadList(fileList);
                  }
                  // setFileUploadList(e.target.files)
                }}
              />
              {["/dtr"].includes(pathname)
                ? "(Max. 5 MB)"
                : ["/wc-claims"].includes(pathname)
                  ? "(Max. 15 MB)"
                  : ["/tech-eo", "/tech-do"].includes(pathname)
                    ? "(Max. 50 MB)"
                    : "(Max. 2 MB)"}
            </Button>
          </Box>

          <List dense={true}>
            {Array(fileUploadList.length)
              .fill(1)
              .map((fileUploadVal: any, index: number) => {
                return (
                  <ListItem
                    sx={{ px: 0, pt: 1 }}
                    key={`${fileUploadList[index]?.name}+${index}`}
                  >
                    <ListItemText primary={fileUploadList[index]?.name} />
                  </ListItem>
                );
              })}
          </List>

          {fileUploadList.length > 0 && (
            <Button
              variant="contained"
              color="primary"
              sx={{ p: 1, px: 2, width: "unset", mb: 2, fontSize: "0.8rem" }}
              onClick={() => {
                handleFileUpload();
              }}
              disabled={uploadLoading}
            >
              {uploadLoading ? "Loading..." : "Submit Upload"}
            </Button>
          )}

          <Divider />

          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            pt={1.5}
            sx={{ fontSize: "1rem", fontWeight: 600 }}
          >
            {pathToTitleMapping[pathname]}
          </Typography>
          <FormGroup sx={{ pb: 1 }}>
            {fileList &&
              fileList?.map((file: Record<string, any>, index: number) => {
                return (
                  <FormControlLabel
                    key={index}
                    control={
                      <Checkbox
                        checked={file.isSelected}
                        onChange={(event) =>
                          setFileList((prev: Record<string, any>[]) => {
                            prev[index].isSelected = event?.target?.checked;
                            return [...prev];
                          })
                        }
                      />
                    }
                    label={file?.name?.split("/")?.pop()}
                    sx={{ width: "100%" }}
                    componentsProps={{
                      typography: {
                        sx: { fontSize: "0.8rem" },
                      },
                    }}
                  />
                );
              })}
          </FormGroup>

          <Divider />

          <Button
            variant="text"
            color="primary"
            sx={{ p: 1, mt: 1.5, width: "unset" }}
            onClick={() => {
              !uploadLoading && handleClose();
            }}
          >
            Close
          </Button>
        </>
      )}
    </>
  );
}
